import {
  get,
  post
} from './http'

export default {
  getContactList(openid, cid) {
    return get('User/getUserContact', {
      openid: openid,
      cid: cid
    });
  },
  updateContact(openid, contactModel) {
    return post(`User/setUserContact?openid=${openid}`, contactModel);
  }
}



// WEBPACK FOOTER //
// ./src/request/contactApi.js